import React, { useEffect, useState } from 'react';
import { Space, Card, Switch, Select, Row, Col, Modal, Tooltip, Collapse } from 'antd';
import { MdOutlineSpellcheck } from 'react-icons/md';
import { FaRegClock } from 'react-icons/fa';
import { CalculatorOutlined, SoundOutlined, AudioOutlined, StopOutlined } from '@ant-design/icons';
import { RiFontSize } from 'react-icons/ri';
import { CgFontSpacing } from 'react-icons/cg';
import { SolarCloudsBroken } from "/src/components/UI/Icons/SolarIcons";
import "./AccommodationModal.scss";
import AddTimeBtn from '../../Experiences/ExperienceShow/Components/AddTimeBtn';
import { convertToHoursAndMinutes, extraTimeValues, } from '/src/lib/utils/helperMethods';
import { useTranslate } from '/src/lib/MrTranslate/MrTranslate';
import { enabledFeaturesSelector } from '../../Auth/Login/selector';
import { useSelector } from 'react-redux';
import { activeAdjustedExperienceSelector } from '../../Experiences/selector';

const AccommodationItem = ({ key, label, action }) => (
  <Row key={key} className="accommodation-content" align="middle" justify="end">
    <Col>{label}</Col>
    <Col>{action}</Col>
  </Row>
);
const AccommodationModal = (props) => {
  console.log('AccommodationModal===>>>>>>', props);
  const { name, shouldDisabled = false, tooltipTitle = "", onChange, isAccommodationModalOpen, closeModal, hideAddTime, monitorView = false, addTimeBtnProps, countDownTimer, accommodations, defaultMonitorAccommodations } = props;
  const enabledFeatures = useSelector(enabledFeaturesSelector());
  



  const sttPluginEnabled = enabledFeatures.speech_to_text_plugin
  const textToSpeechEnabled = enabledFeatures.text_to_speech





  // console.log('CHECK ENABLE SETTINGS ====>', );

  const mrIntl = useTranslate();
  const defaultAccommodations = {
    spellcheck: false, 
    additional_time: '0',
    additional_time_type: 'percentage',
    calc_enabled: false, 
    graphing_calc_enabled: false, 
    tts_allowed: false,
    stt_allowed: false,
    dyslexia_font: "",
    // font_size: 'Default',
    // font_spacing: 'Default',
    legacy_ap_mac_9_0_2_allowed: false,
    ...defaultMonitorAccommodations, //Add default true if enable from delivery settings
  };

  const [localAccommodations, setLocalAccommodations] = useState(accommodations);
  const [loading, setLoading] = useState(false);

  const originalDuration = addTimeBtnProps?.experienceDuration || 0;
  const localAccommodationsExtraTime = localAccommodations?.extra_time_data?.extra_time;
  
  const getExtraTime = (extraTime) => extraTime ? parseInt(extraTime) / 60000 : 0;
  const extraTimeInMinutes =
  localAccommodationsExtraTime ? getExtraTime(localAccommodationsExtraTime) : getExtraTime(addTimeBtnProps?.item?.extra_time);

  const totalDuration = parseInt(originalDuration) + extraTimeInMinutes;
  
  if (monitorView) {
    defaultAccommodations.extra_time_data = {}
  }

  const shouldShowTotalDuration = extraTimeInMinutes > 0;

  const currentAccommodations = {
    ...defaultAccommodations,
    ...localAccommodations
  };

  console.log('currentAccommodations ====>', currentAccommodations, 'accommodations ====>', accommodations);
  useEffect(() => {
    if (!isAccommodationModalOpen) {
      setLoading(false);
    }
  }, [isAccommodationModalOpen]);

  useEffect(() => {
    if (accommodations) {
      setLocalAccommodations(accommodations);
    }
  }, [accommodations]);

  const handleAccommodationChange = (key, value) => {
    console.log('key===>>>>>>', key, value);
    if (loading) return;
    const newAccommodations = {
      ...localAccommodations,
      [key]: value,
    };

    if (key === "additional_time_type") {
      newAccommodations.additional_time = "0";
    }

    setLocalAccommodations(newAccommodations);
  }
  
  const onCancel = () => {
    setLocalAccommodations(accommodations);
    closeModal();
  }
  const handleOk = () => {
    setLoading(true)
    onChange(localAccommodations);
  }
  
  const additionalTimeValues =
    currentAccommodations.additional_time_type === "percentage"
      ? [
        { value: "0", label: '0%' },
        { value: "10", label: '10%' },
        { value: "25", label: '25%' },
        { value: "50", label: '50%' },
        { value: "75", label: '75%' },
        { value: "100", label: '100%' }
      ]
      : [
        { value: "0", label: "0" },
        ...extraTimeValues.map(minutes => ({ value: minutes, label: minutes }))
      ];

  const collapsibleItems = [
    {
      key: 'item-1',
      label: mrIntl("AccommodationModal.legacy_app"),
      children: (
        <Card className='legacy-app-item'>
         <AccommodationItem
          key={'legacy-ap-mac-9-0-2'}
          label={<><StopOutlined /> {mrIntl("AccommodationModal.ap_mac_9_0_2")}</>}
          action={<Switch
            size="small"
            checked={localAccommodations?.legacy_ap_mac_9_0_2_allowed || false}
            onChange={(checked) => handleAccommodationChange('legacy_ap_mac_9_0_2_allowed', checked)}
            disabled={shouldDisabled || loading}
          />}
        />
        </Card>
      ),
    },
  ];
  const showBasicAccommodation = enabledFeatures.spellcheck || !monitorView || !hideAddTime;
  return (
    <Modal
      key={"accommodation-modal"}
      title={`${mrIntl("CommonText.set_accommodation_for")} ${name}`}
      open={isAccommodationModalOpen}
      onOk={handleOk}
      onCancel={onCancel}
      maskClosable={false}
      okButtonProps={{
        disabled: loading,
        loading: loading,
      }}
      cancelButtonProps={{
        disabled: loading
      }}
    >
      <div className="student-accommodations-main-content">
        <div className="student-accommodations-inner-content">
         {showBasicAccommodation && <div className="accommodation-card">
            <p>{mrIntl("AccommodationModal.basic_accommodation")}</p>
            <Card key={"basic-accommodation-card"}>
              {enabledFeatures.spellcheck ?
                <AccommodationItem
                  key={'spellcheck'}
                  label={<><MdOutlineSpellcheck /> {mrIntl("CommonText.spellcheck")}</>}
                  action={<Tooltip title={tooltipTitle}>
                    <Switch
                      size="small"
                      checked={currentAccommodations.spellcheck || false}
                      onChange={(checked) => handleAccommodationChange('spellcheck', checked)}
                      disabled={shouldDisabled || loading}
                    />
                  </Tooltip>}
                /> : null
              }
              {monitorView
                ? !hideAddTime
                  ?
                  <>
                    <AccommodationItem
                      key={'original-duration'}
                      label={<><FaRegClock /> {mrIntl("AccommodationModal.original_duration")}</>}
                      action={`${convertToHoursAndMinutes(originalDuration)}`}
                    />

                    <AccommodationItem
                      key={'extra-time'}
                      label={<><FaRegClock /> {"Total Extra Time (minutes)"}</>}
                      action={<AddTimeBtn
                        key={`modal-add-time-btn`}
                        {...addTimeBtnProps}
                        item={{
                          ...addTimeBtnProps.item,
                          ...currentAccommodations.extra_time_data,
                        }}
                        updateRecord={(uid, data, item, options) => handleAccommodationChange("extra_time_data", data)}
                      />}
                    />

                    {shouldShowTotalDuration &&
                      <AccommodationItem
                        key={'total-duration'}
                        label={mrIntl("AccommodationModal.new_total_duration")}
                        action={`${convertToHoursAndMinutes(totalDuration)}`}
                      />
                    }
                    {countDownTimer && <AccommodationItem
                      key={'time-remaining'}
                      label={mrIntl("AccommodationModal.time_remaining")}
                      action={countDownTimer}
                    />}
                  </>
                  : null
                :
                <AccommodationItem
                  key={'additional-time'}
                  label={<><FaRegClock /> {mrIntl("AccommodationModal.additional_time")}</>}
                  action={<Space>
                    <Select
                      popupMatchSelectWidth={false}
                        value={currentAccommodations.additional_time}
                        onChange={(value) => handleAccommodationChange('additional_time', value)}
                        options={additionalTimeValues}
                      />
                      <Tooltip title={tooltipTitle}>
                        <Switch
                          size="large"
                          checkedChildren="%"
                          unCheckedChildren="mins"
                          checked={currentAccommodations.additional_time_type === "percentage"}
                          onChange={(value) => handleAccommodationChange("additional_time_type", value ? "percentage" : "minutes")}
                          disabled={shouldDisabled || loading}
                        />
                      </Tooltip>
                    </Space>
                  }
                />
              }
            </Card>
          </div>}
          <div className="accommodation-card">
            <p>{mrIntl("AccommodationModal.math_tools")}</p>
            <Card key={"math-tools-card"}>
              <AccommodationItem
                key={'calc-enabled'}
                label={<><CalculatorOutlined /> {mrIntl("AccommodationModal.desmos_scientific_calculator")}</>}
                action={<Tooltip title={tooltipTitle}>
                  <Switch
                    size="small"
                    checked={currentAccommodations.calc_enabled || false}
                    onChange={(checked) => handleAccommodationChange('calc_enabled', checked)}
                    disabled={shouldDisabled || loading}
                  />
                </Tooltip>}
              />
              <AccommodationItem
                key={'graphing-calc-enabled'}
                label={<><CalculatorOutlined /> {mrIntl("AccommodationModal.desmos_graphing_calculator")}</>}
                action={<Tooltip title={tooltipTitle}>
                  <Switch
                    size="small"
                    checked={currentAccommodations.graphing_calc_enabled || false}
                    onChange={(checked) => handleAccommodationChange('graphing_calc_enabled', checked)}
                    disabled={shouldDisabled || loading}
                  />
                </Tooltip>}
              />
            </Card> 
          </div>
          <div className="accommodation-card">
            <p>{mrIntl("AccommodationModal.reading_support")}</p>
            <Card key={"reading-support-card"}>
              {textToSpeechEnabled ?
                <AccommodationItem
                  key={'tts-allowed'}
                  label={<><SoundOutlined /> {mrIntl("CommonText.text_to_speech")}</>}
                  action={<Tooltip title={tooltipTitle}>
                    <Switch
                      size="small"
                      checked={currentAccommodations.tts_allowed || false}
                      onChange={(checked) => handleAccommodationChange('tts_allowed', checked)}
                      disabled={shouldDisabled || loading}
                    />
                  </Tooltip>}
                /> : null}
              {sttPluginEnabled ? <AccommodationItem
                key={'stt-allowed'}
                label={<><AudioOutlined /> {mrIntl("CommonText.speech_to_text")}</>}
                action={<Tooltip title={tooltipTitle}>
                  <Switch
                    size="small"
                    checked={currentAccommodations.stt_allowed || false}
                    onChange={(checked) => handleAccommodationChange('stt_allowed', checked)}
                    disabled={shouldDisabled || loading}
                  />
                </Tooltip>}
              /> : null}
              {enabledFeatures.dyslexia_font && !monitorView ? <AccommodationItem
                label={<><SolarCloudsBroken /> {mrIntl("AccommodationModal.dyslexia_font")}</>}
                action={
                  <Space>
                    <Tooltip title={tooltipTitle}>
                      <Switch
                        size="small"
                        checked={currentAccommodations.dyslexia_font}
                        onChange={(checked) => handleAccommodationChange('dyslexia_font', checked ? 'lexie_readable' : '')}
                        disabled={shouldDisabled}
                      />
                    </Tooltip>
                    {currentAccommodations.dyslexia_font && (
                      <Select
                        className='dyslexia-font-select'
                        popupMatchSelectWidth={false}
                        value={currentAccommodations.dyslexia_font}
                        showSearch
                        options={[
                          { value: 'lexie_readable', label: "Lexie Readable"},
                          { value: 'open_dyslexic', label: "Open Dyslexic" },
                          { value: 'sf_pro', label: "SF Pro" },
                        ]}
                        onChange={(value) => handleAccommodationChange('dyslexia_font', value)}
                      />
                    )}
                  </Space>
                }
              /> : null}
            </Card> 
          </div>
          {!monitorView && (
            <div className="accommodation-card">
              <Collapse bordered={false} items={collapsibleItems} className='legacy-app'></Collapse>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default AccommodationModal;
